import { IntlShape } from "react-intl";
import Swal from "sweetalert2";

export const showWarningMessage = (intl: IntlShape) => {
  Swal.fire({
    title: intl.formatMessage({ id: "Warning" }),
    icon: "warning",
    text: intl.formatMessage({ id: "NotHaveMia" }),
    showConfirmButton: true,
    confirmButtonText: intl.formatMessage({ id: "Accept" }),
    confirmButtonColor: "#3f51b5",
    customClass: {
      container: "swal-container-z-index",
    },
  });
};

export const openExternalUrl = (url: string) => {
  window.open(url);
};
